import React from 'react';
import { createBrowserRouter, Navigate, useParams } from 'react-router-dom';

import App from './main';
import { RetryErrorBoundary } from './retry-error-boundary';
import Dashboard from 'pages/dashboard';
import Products from 'pages/products/index';
import ProductBundlesList from 'pages/products/servicetypes';
import Pricelists from 'pages/prices/index';
import AvailabilityIndex from 'pages/availability/index';
import Offers from 'pages/offers/index';
import Invoices from 'pages/invoices/index';
import Security from 'pages/settings/security/index';
import Users from 'pages/settings/users/index';
import Spaces from 'pages/settings/spaces/index';
import Space from 'pages/settings/space/index';
import SettingsHotelsIndex from 'pages/settings/hotels';
import SettingsIntegrationIndex from 'pages/settings/integration';
import Login from 'layout/login';
import GuestOfferPage from 'pages/offers/guest-offer';
import ErrorPage from 'pages/error';
import ContentProductsList from 'pages/content/products';
import MediaList from 'pages/content/media';
import ContentTemplatesIndex from 'pages/content/templates';
import TasksBoard from 'pages/tasks/tasks';
import TasksIndex from 'pages/tasks';
import TasksSettingsIndex from 'pages/tasks/tasks_settings';
import ClientsIndex from 'pages/clients';
import GroupsIndex from 'pages/groups';
import Booking from 'pages/bookings/booking';
import BookingsRedirect from 'pages/bookings/BookingsRedirect';
import SearchIndex from 'pages/search';
import ContractsRoutes from 'pages/contracts';
import CompanyContractDetail from 'pages/contracts/CompanyContractDetail';
import AdministrationIndex from 'pages/administration';

function BookingRoute() {
  const { id } = useParams();
  return <Booking id={parseInt(id!)} />;
}

function LoginResetRoute() {
  const { passwordResetCode } = useParams();
  return <Login passwordResetCode={passwordResetCode!} />;
}

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: '',
        element: <Dashboard />,
      },
      {
        path: 'products/*',
        element: <Products />,
      },
      {
        path: 'servicetypes/*',
        element: <ProductBundlesList />,
      },
      {
        path: 'offers/*',
        element: (
          <RetryErrorBoundary>
            <Offers />
          </RetryErrorBoundary>
        ),
      },
      {
        path: 'tasks/*',
        element: <TasksIndex />,
      },
      {
        path: 'tasks/settings/*',
        element: <TasksSettingsIndex />,
      },
      {
        path: 'bookings',
        element: <BookingsRedirect />,
      },
      {
        path: 'bookings/:id',
        Component: BookingRoute,
      },
      {
        path: 'clients/*',
        element: <ClientsIndex />,
      },
      {
        path: 'groups/*',
        element: <GroupsIndex />,
      },
      {
        path: 'contracts/*',
        element: <ContractsRoutes />,
      },
      {
        path: 'company-contracts/new',
        element: <CompanyContractDetail isEdit isCreate />,
      },
      {
        path: 'company-contracts/:id',
        element: <CompanyContractDetail />,
      },
      {
        path: 'company-contracts/:id/edit',
        element: <CompanyContractDetail isEdit />,
      },
      {
        path: 'search/*',
        element: <SearchIndex />,
      },
      {
        path: 'invoices/*',
        element: <Invoices />,
      },
      {
        path: 'content/texts/*',
        element: <ContentProductsList />,
      },
      {
        path: 'content/media/*',
        element: <MediaList />,
      },
      {
        path: 'content/templates/*',
        element: <ContentTemplatesIndex />,
      },
      {
        path: 'pricelists/*',
        element: <Pricelists />,
      },
      {
        path: 'availability/*',
        element: <AvailabilityIndex />,
      },
      {
        path: 'settings/hotels/*',
        element: <SettingsHotelsIndex />,
      },
      {
        path: 'settings/users/*',
        element: <Users />,
      },
      {
        path: 'settings/spaces/*',
        element: <Spaces />,
      },
      {
        path: 'settings/security/*',
        element: <Security />,
      },
      {
        path: 'settings/integration/*',
        element: <SettingsIntegrationIndex />,
      },
      {
        path: 'settings/space/*',
        element: <Space />,
      },
      {
        path: 'administration/*',
        element: <AdministrationIndex />,
      },
      {
        path: 'meeting-package-import',
        element: <Navigate to="/administration/system?section=meeting-package" replace />,
      },
      {
        path: 'error',
        element: <ErrorPage />,
      },
    ],
  },
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/offers/access/:id',
    element: <GuestOfferPage />,
  },
  {
    path: '/forgotpassword/:passwordResetCode',
    Component: LoginResetRoute,
  },
]);

export default router;
